import { render, staticRenderFns } from "./form-view.vue?vue&type=template&id=5f573b5e&scoped=true&"
import script from "./form-view.vue?vue&type=script&lang=js&"
export * from "./form-view.vue?vue&type=script&lang=js&"
import style0 from "./form-view.vue?vue&type=style&index=0&id=5f573b5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f573b5e",
  null
  
)

component.options.__file = "form-view.vue"
export default component.exports